import Icon from '../components/Icon.vue'

Icon.register({
  'trash-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M32 464v-336h384v336c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48zM304 208v224c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 208v224c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16s-16 7.2-16 16zM112 208v224c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16s-16 7.2-16 16zM432 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h120l9.4-18.7c3.6-7.3 13.1-13.3 21.3-13.3h0.1 114.3 0c8.2 0 17.8 6 21.5 13.3l9.4 18.7h120z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/trash-alt.js
// module id = 2029
// module chunks = 0